'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserPermission() {
}
export { $c_Lapp_data_GeneralPracticeUserPermission as $c_Lapp_data_GeneralPracticeUserPermission };
$c_Lapp_data_GeneralPracticeUserPermission.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserPermission.prototype.constructor = $c_Lapp_data_GeneralPracticeUserPermission;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserPermission() {
}
export { $h_Lapp_data_GeneralPracticeUserPermission as $h_Lapp_data_GeneralPracticeUserPermission };
$h_Lapp_data_GeneralPracticeUserPermission.prototype = $c_Lapp_data_GeneralPracticeUserPermission.prototype;
$c_Lapp_data_GeneralPracticeUserPermission.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-General-Practice-User-Permission.js.map
